import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-brush-icon',
  templateUrl: './design-brush.component.html'
})
export class DesignBrushComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
